import { Formik, Field, Form } from 'formik';

import { FormControl } from '@/core/components/form-components/FormControl';
import { Widget, WidgetBody, WidgetTitle } from '@/core/components/widget';
import { UserViewModel } from '@/core/models/user';
import { TeamViewModel } from '@/core/models/team';
import { Input } from '@/core/components/form-components/Input';
import { UsersSelector } from '@/core/components/UsersSelector';
import { LoadingButton } from '@/core/components/Button/LoadingButton';

import { validationSchema } from './CreateTeamForm.validation';

export interface FormValues {
  name: string;
  leaders: number[];
}

interface Props {
  users: UserViewModel[];
  teams: TeamViewModel[];
  onSubmit(values: FormValues): void;
}

export function CreateTeamForm({ users, teams, onSubmit }: Props) {
  const initialValues = {
    name: '',
    leaders: [],
  };

  return (
    <div className="row">
      <div className="col-lg-12 col-md-12 col-xs-12">
        <Widget>
          <WidgetTitle icon="fa-plus" title="Создание команды" />
          <WidgetBody>
            <Formik
              initialValues={initialValues}
              validationSchema={() => validationSchema(teams)}
              onSubmit={onSubmit}
              validateOnMount
            >
              {({
                values,
                errors,
                handleSubmit,
                setFieldValue,
                isSubmitting,
                isValid,
              }) => (
                <Form
                  className="form-horizontal"
                  onSubmit={handleSubmit}
                  noValidate
                >
                  <FormControl
                    inputId="team_name"
                    label="Название"
                    errors={errors.name}
                  >
                    <Field
                      as={Input}
                      name="name"
                      id="team_name"
                      required
                      placeholder="например: development"
                      data-cy="team-teamNameInput"
                    />
                  </FormControl>

                  {users.length > 0 && (
                    <FormControl
                      inputId="users-input"
                      label="Руководители команды"
                      tooltip="Можно назначить одного или нескольких руководителей команды. Руководитель управляет составом команды и её ресурсами."
                      errors={errors.leaders}
                    >
                      <UsersSelector
                        value={values.leaders}
                        onChange={(leaders) =>
                          setFieldValue('leaders', leaders)
                        }
                        users={users}
                        dataCy="team-teamLeaderSelect"
                        inputId="users-input"
                        placeholder="Выберите одного или нескольких руководителей"
                      />
                    </FormControl>
                  )}

                  <div className="form-group">
                    <div className="col-sm-12">
                      <LoadingButton
                        disabled={!isValid}
                        dataCy="team-createTeamButton"
                        isLoading={isSubmitting}
                        loadingText="Создание команды…"
                      >
                        <i
                          className="fa fa-plus space-right"
                          aria-hidden="true"
                        />
                        Создать команду
                      </LoadingButton>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </WidgetBody>
        </Widget>
      </div>
    </div>
  );
}
